import { PieChart } from "lucide-react";

import { donutFaixas } from "../../lib/faixa";
import { KpiCard } from "../layout/KpiCard";

// Rótulos curtos para o KPI compacto (o donut usa os longos de FAIXA_META).
const CURTO = {
  "Acima da média": "Acima",
  "Na média": "Média",
  "Abaixo da média": "Abaixo",
  "Sem referência": "S/ ref."
};

/** Distribuição por faixa em formato de KPI compacto — barra empilhada + legenda
 * de percentuais. Reaproveita a casca do KpiCard (borda, filete, animação) e o
 * consolidador `donutFaixas`. Usado no cabeçalho de KPIs do Gestor (rede/região). */
export function FaixaKpiCompacta({
  faixas,
  loading = false,
  /* Não usa o slot 4 (vermelho): este card fica na mesma grade do KPI "Alunos
     inativos", que já é vermelho por ser alerta — dois filetes vermelhos lado a
     lado sugeriam que a distribuição por faixa também era um problema. */
  accent = "var(--color-chart-3)"
}) {
  const segs = donutFaixas(faixas);
  const total = segs.reduce((s, d) => s + d.value, 0);

  return (
    <KpiCard
      label="Distribuição por faixa"
      accent={accent}
      icon={<PieChart size={16} />}
    >
      {loading ? (
        <div className="h-2.5 w-full animate-pulse rounded-full bg-[var(--color-surface-3)]" />
      ) : total === 0 ? (
        <div className="py-1 text-[13px] text-[var(--color-ink-faint)]">
          Sem dados de faixa
        </div>
      ) : (
        <>
          <div className="flex h-2.5 w-full overflow-hidden rounded-full bg-[var(--color-surface-3)]">
            {segs.map(s => (
              <span
                key={s.name}
                className="h-full"
                style={{
                  width: `${(s.value / total) * 100}%`,
                  background: s.color
                }}
                title={`${s.name}: ${s.value}`}
              />
            ))}
          </div>
          <div className="mt-2.5 flex flex-col gap-1">
            {segs.map(s => (
              <span
                key={s.name}
                className="flex items-center gap-1.5 text-[11px] text-[var(--color-ink-soft)]"
              >
                <span
                  className="h-2 w-2 flex-none rounded-full"
                  style={{ background: s.color }}
                />
                <span className="tnum w-8 font-semibold text-[var(--color-ink)]">
                  {Math.round((s.value / total) * 100)}%
                </span>
                {CURTO[s.name] ?? s.name}
              </span>
            ))}
          </div>
        </>
      )}
    </KpiCard>
  );
}
